import { makeApolloClient } from './makeApolloClient'

/**
 * Send graphql queries using Apollo client
 */
export const apolloWordPressClient = makeApolloClient()
